import React from 'react';
import { useI18n } from '../../../contexts/I18nContext';
import AiToolTemplateV2 from '../../AiToolTemplate/AiToolTemplateV2';
import { 
  createComponentConfig, 
  createComponentItem,
  COMPONENT_TYPES,
  PROMPT_STRATEGIES,
  TOOL_IDS
} from '../../AiToolTemplate/config/componentConfig';

const ProfessionalPortrait = () => {
  const { t } = useI18n();

  // 创建ProfessionalPortrait的配置
  const professionalPortraitConfig = createComponentConfig({
    components: [
      createComponentItem({
        type: COMPONENT_TYPES.IMAGE_UPLOAD,
        id: 'sourceImage',
        title: t('aiToolTemplate.uploadImage'),
        description: t('aiToolTemplate.uploadImageDescription'),
        required: true,
        props: {
          acceptedFormats: ['jpg', 'jpeg', 'png', 'gif', 'webp'],
          maxSize: 10 * 1024 * 1024, // 10MB
          preview: true,
          cropAspectRatio: null,
          placeholder: t('aiToolTemplate.clickOrDragUpload')
        },
        order: 1
      }),
      createComponentItem({
        id: 'size',
        type: COMPONENT_TYPES.SIZE_SELECTOR,
        title: t('aiWorkbench.aspectRatio'),
        required: true,
        defaultValue: 'Auto',
        order: 2
      }),
      createComponentItem({
        id: 'portraitIndustry',
        type: COMPONENT_TYPES.TAG_SELECTOR,
        required: false,
        props: {
          dictName: 'portraitIndustry',
          allowMultiple: false
        },
        order: 3
      }),
      createComponentItem({
        id: 'portraitSetting',
        type: COMPONENT_TYPES.TAG_SELECTOR,
        required: false,
        props: {
          dictName: 'portraitSetting',
          allowMultiple: false
        },
        order: 4
      }),
      createComponentItem({
        id: 'portraitOutfit',
        type: COMPONENT_TYPES.TAG_SELECTOR,
        required: false,
        props: {
          dictName: 'portraitOutfit',
          allowMultiple: false
        },
        order: 5
      }),
      createComponentItem({
        id: 'portraitLighting',
        type: COMPONENT_TYPES.TAG_SELECTOR,
        required: false,
        props: {
          dictName: 'portraitLighting',
          allowMultiple: false
        },
        order: 6
      }),
      createComponentItem({
        type: COMPONENT_TYPES.PROMPT_INPUT,
        id: 'supplementaryPrompt',
        title: t('aiToolTemplate.supplementaryPrompt'),
        description: t('aiToolTemplate.supplementaryPromptDescription'),
        required: false,
        props: {
          placeholder: t('aiToolTemplate.enterSupplementaryPrompt')
        },
        order: 7
      })
    ],
    promptConfig: {
      strategy: PROMPT_STRATEGIES.CUSTOM,
      customHandler: (values) => {
        return values.supplementaryPrompt;
      }
    },
    additionalParams: {
      model: 'nano',
      width: 1024,
      height: 1024,
      style: 'professional-portrait'
    }
  });

  return (
    <AiToolTemplateV2
      toolName={t('aiToolTemplate.tools.professionalPortrait.name')}
      toolIcon="👔"
      toolDescription={t('aiToolTemplate.tools.professionalPortrait.description')}
      config={professionalPortraitConfig}
      gradientColors={['#667eea', '#764ba2']}
      toolId={TOOL_IDS.PROFESSIONAL_PORTRAIT}
    />
  );
};

export default ProfessionalPortrait;
